<div class="w-full mt-3 flex flex-column border-1 border-300 border-round-lg">
  <div class="w-full p-4 flex flex-column gap-4">

    <h2 class="text-left font-medium text-xl m-0" style="color: #000086;">Alumni</h2>

    <!-- Loading skeletons -->
    <div *ngIf="isLoading" class="grid">
      <div *ngFor="let i of [1,2,3]" class="col-12 sm:col-6 md:col-4">
        <div class="p-4 border-1 border-300 border-round-lg flex flex-column align-items-center gap-3"
          style="background-color: #F9FAFB;">
          <div class="border-round-lg bg-gray-200" style="width:5rem;height:5rem;"></div>
          <div class="bg-gray-200 border-round" style="width:8rem;height:1rem;"></div>
          <div class="bg-gray-200 border-round" style="width:10rem;height:0.75rem;"></div>
        </div>
      </div>
    </div>

    <!-- Empty state -->
    <div *ngIf="!isLoading && alumniList.length === 0"
      class="flex align-items-center justify-content-center gap-2 py-5 text-bluegray-400">
      <i class="pi pi-info-circle text-xl"></i>
      <span class="font-medium text-base">No alumni records found for this institution.</span>
    </div>

    <!-- Alumni grid -->
    <div *ngIf="!isLoading && alumniList.length > 0" class="grid">
      <div *ngFor="let alumni of visibleAlumni; trackBy: trackById" class="col-12 sm:col-6 md:col-4">
        <div class="w-full flex flex-column align-items-center gap-3 p-4 border-1 border-300 border-round-lg text-center cursor-pointer hover:shadow-2 transition-duration-200"
          style="background-color: #F9FAFB;"
          (click)="showAlumniDetails(alumni)">

          <!-- Photo (Square) -->
          <div class="border-round-lg overflow-hidden flex-shrink-0"
            style="width:6rem;height:6rem;border:2px solid #000086;">
            <img
              [src]="alumni.photoUrl || 'assets/images/logo-placeholder.png'"
              [alt]="alumni.firstName"
              style="width:100%;height:100%;object-fit:cover;display:block;"
              (error)="onImgError($event)" />
          </div>

          <!-- Name -->
          <b class="text-base font-bold" style="color: #12263F;">
            {{ alumni.firstName }} {{ alumni.lastName || '' }}
          </b>

        </div>
      </div>
    </div>

    <!-- View All / Show Less -->
    <div *ngIf="alumniList.length > initialCount" class="flex justify-content-end">
      <button
        class="px-4 py-2 text-base font-semibold border-none border-round cursor-pointer text-blue-600 bg-transparent"
        style="text-decoration: underline;"
        (click)="toggleView()">
        {{ showAll ? 'Show Less' : 'View All Alumni' }}
      </button>
    </div>

  </div>
</div>

<!-- Alumni Details Dialog -->
<p-dialog 
  [(visible)]="displayAlumniDialog" 
  header="Alumni Details" 
  [modal]="true" 
  [draggable]="false" 
  [resizable]="false"
  [breakpoints]="{ '960px': '75vw', '641px': '90vw' }" 
  [style]="{ width: '400px' }">
  
  <div *ngIf="selectedAlumni" class="flex flex-column align-items-center gap-4 py-4">
    <!-- Enlarged Photo (Square) -->
    <div class="border-round-lg overflow-hidden shadow-2"
      style="width:10rem;height:10rem;border:3px solid #000086;">
      <img
        [src]="selectedAlumni.photoUrl || 'assets/images/logo-placeholder.png'"
        [alt]="selectedAlumni.firstName"
        style="width:100%;height:100%;object-fit:cover;display:block;"
        (error)="onImgError($event)" />
    </div>

    <!-- Details -->
    <div class="text-center">
      <h3 class="m-0 text-xl font-bold" style="color: #000086;">
        {{ selectedAlumni.firstName }} {{ selectedAlumni.lastName || '' }}
      </h3>
      
      <div class="mt-3 flex flex-column gap-2">
        <ng-container *ngIf="selectedAlumni.descriptionOrUrl">
          <a *ngIf="isUrl(selectedAlumni.descriptionOrUrl)"
            [href]="ensureHttp(selectedAlumni.descriptionOrUrl)"
            target="_blank"
            rel="noopener noreferrer"
            class="text-base font-semibold hover:underline"
            style="color: #1E75E1; word-break: break-all;">
            {{ selectedAlumni.descriptionOrUrl }}
          </a>
          <p *ngIf="!isUrl(selectedAlumni.descriptionOrUrl)"
            class="text-base font-medium m-0"
            style="color: #3B506C; word-break: break-word;">
            {{ selectedAlumni.descriptionOrUrl }}
          </p>
        </ng-container>
      </div>
    </div>
  </div>
</p-dialog>
